export const AppTheme = {
    light: 'light',
    dark: 'dark',
    main: 'main'
};
